import React from 'react';




export class ubicacion extends React.Component {

	componentDidMount () {
        const script = document.createElement("script");

        script.async = true;
        
		script.innerHTML = "$('.sss')"; 

        document.body.appendChild(script);


    }



	render(){
		return (
			<div id="ubicacion">
		
				<section class="container-fluid quienes-somos-container">
						<article class="row justify-content-md-center">
							<div class="col-12">
								<div class="bg-box-form">
									<div class="mapa">
										<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.0936146393838!2d-58.321720484767695!3d-34.702818680434014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a33266b8769579%3A0x79e4a152021a3fbe!2sAv.+Bartolom%C3%A9+Mitre+6163%2C+B1875ABE+Gran+Buenos+Aires%2C+Buenos+Aires!5e0!3m2!1sen!2sar!4v1526606297704" width="" height="490" frameborder="0" allowfullscreen></iframe>
									</div>
									<h2>Ubicación</h2>
									<p>Av. Bartolomé Mitre 6163, Wilde, Buenos Aires</p>
									<p>Telefonos: (011) 4207-2880/7719/6914 Whatsapp: (011) 2526-7412</p>
									<p>Email: elemporiodelbulon@gmail.com</p>
								</div>
								
							</div>
						</article>
						
					</section>
			</div>
		);
	}
} 


// WEBPACK FOOTER //
// ./src/components/ubicacion.js